import { Box, styled } from '@mui/material';

export const FiltersContainer = styled(Box)(({ theme }) => ({
  gridGap: theme.spacing(1),
  display: 'grid',
  gridTemplateColumns: '1fr',
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: '1fr 1fr 1fr',
  },
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
  },
  [theme.breakpoints.up('xl')]: {
    gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
  },
}));
